import { render, staticRenderFns } from "./OSlider.vue?vue&type=template&id=a071b12c"
import script from "./OSlider.vue?vue&type=script&lang=js"
export * from "./OSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports